module.exports = __webpack_public_path__ + "img/2.b73f8732.png";